import React from 'react';
import styles from './AnimatedBG.module.scss';

const AnimatedBG = ({ isLandscape }) => {
  return (
    <div className={styles.lobby}>
      <div className={`${styles.bg} ${styles.base}`}></div>
      <div className={`${styles.bg} ${styles.particles}`}></div>
      <div className={`${styles.bg} ${styles.glow}`}></div>
    </div>
  );
};

export default AnimatedBG;